import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { RuntimeSlideModel } from '../../runtime/slides/models';
import { ReplaceNonBreakingSpacesPipe } from '../../shared/pipes/replace-non-breaking-spaces.pipe';
import { PresentationController } from '../presentation-controller';
import { ScrollContentDirective } from '../scroll-content.directive';

@Component({
  selector: 'ds-slide-text',
  imports: [TranslatePipe, ReplaceNonBreakingSpacesPipe, ScrollContentDirective],
  templateUrl: './slide-text.component.html',
  styleUrls: ['./slide-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideTextComponent {
  public readonly slide = input.required<RuntimeSlideModel>();
  public readonly controller = input.required<PresentationController>();

  public readonly content = computed(() => this.slide().content);
  public readonly isNews = computed(() => this.slide().kind === 'news');
  // The birthday feed arrives on the API's channel -1 and is shown without a source label.
  public readonly showLabel = computed(() => !this.content().providerChannelIds?.includes(-1));
  public readonly courseTitle = computed(() => {
    const dining = this.content().diningContent;

    return this.slide().kind === 'dining' && dining?.length === 1 ? dining[0].course : null;
  });
  public readonly hasIcons = computed(() => !!this.content().hasZoom || !!this.content().hasYoutube);
  public readonly hasLabelRow = computed(() => this.showLabel() && (this.content().label !== undefined || this.hasIcons()));
}
